<section>
  <app-admin-page-header>
    <p description>Platform configuration and operational controls.</p>
  </app-admin-page-header>

  <app-settings-reminder-cron-section />

  <nav class="cg-admin-settings-nav">
    <a routerLink="/platform/settings/release-notes" class="cg-admin-settings-nav__link">
      Release Notes
    </a>
  </nav>
</section>
